<template>
    <div class="col-md-12">
        <ManageReasons></ManageReasons>
    </div>
</template>

<script>
import ManageReasons from './reasons/ManageReasons.vue';

export default {
    name: "ConfigSolicitations",
    components: {
        ManageReasons,
    },
    data() {
        return {}
    },
    created() {},
    methods: {
    }
}
</script>